var EqAffectation = {
  RESIDENT: 0,
  COMMON: 1,
  TAMPON: 2,
};

module.exports = EqAffectation;
